
import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart6 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: "basic-bar", 
          type: 'bar',
          height: 430 
        },
        colors: ["#d86a75"],
        plotOptions: {
          bar: {
            horizontal: true,
             barHeight: '20px'
          }
        },
        colors: ["#d86a75"],
        xaxis: {
          categories: props?.categories
        }
      },
       series: [
        {
          name: "",
          data: props?.seriesData
        }
      ]
    };
  }

  render() {
    return (
      <div className="app">
        <div className="row">
          <div className="mixed-chart"  style={{width:"98%"}}>
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="bar"
              height="260"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BarChart6;

